<template>
  <section>
    <h3>
      Damages
    </h3>
    <router-link :to="{name: 'Damage:Create'}">
      <b-button>
        <b-icon
            icon="plus">
        </b-icon>
        Report
      </b-button>
    </router-link>
    <router-link :to="{name: 'Damage:Map'}">
      <b-button>
        <b-icon
            icon="map">
        </b-icon>
        Show Map
      </b-button>
    </router-link>
    <b-table
        :data="formattedDamages"
        :columns="columns">
    </b-table>
  </section>
</template>

<script>
  import {mapActions, mapGetters} from 'vuex'

  export default {
    name: 'ShelterList',
    data() {
      return {
        columns: [
          {
            field: 'name',
            label: 'Name',
            searchable: true,
          },
          {
            field: 'type',
            label: 'Type',
            searchable: true,
          },
          {
            field: 'province',
            label: 'Province',
            searchable: true,
          },
          {
            field: 'location',
            label: 'Location',
            searchable: true,
          },
          {
            field: 'time',
            label: 'Time',
            searchable: true,
          },
          {
            field: 'casualties.death',
            label: 'Casualties',
            searchable: true,
          }
        ]
      }
    },
    mounted () {
      this.fetch()
    },
    computed: {
      ...mapGetters('Damage', ['damages']),
      formattedDamages () {
        return this.damages.map(i => {
          const locs = i.location.split(',')
          return {
            ...i,
            location: locs[0] + ' , ' + locs[1]
          }
        })
      }
    },
    methods: {
      ...mapActions('Damage', ['fetch'])
    }
  }
</script>
